<template>
<div v-if="show" class="card-detail">
  <!-- 提示区 -->
  <div class="card-action">
    <div class="title">工单详情</div>
    <div class="button">
      <a-button v-if="data.workOrderModel.status===0" type="primary" ghost style="margin-right: 10px;" @click="revoke">
        撤单
      </a-button>
      <a-button type="primary" @click="reback">返回列表</a-button>
    </div>
  </div>

  <!-- 状态区 -->
  <a-steps v-if="data.workOrderModel.status!=4" :current="data.workOrderModel.status" style="margin-bottom: 26px;padding: 0 100px;">
    <a-step title="已提交" />
    <a-step title="处理中" />
    <a-step title="已解决" />
    <a-step title="已评价" />
  </a-steps>

  <div class="card-item">
    <div class="item-title">
      <eco-icon name="article" :size="25"></eco-icon>
      <span>工单信息</span>
    </div>
    <div class="item-content">
      <div class="desc-card">
        <div class="item-line-2">
          <div class="item-line-1">
            <div class="label">工单编号</div>
            <div class="content">{{ data.workOrderModel.worksheetId }}</div>
          </div>
          <div class="item-line-1">
            <div class="label">单位名称</div>
            <div class="content">{{ data.workOrderModel.companyName }}</div>
          </div>
        </div>
        <div class="item-line-2">
          <div class="item-line-1">
            <div class="label">联系人</div>
            <div class="content">{{ data.workOrderModel.contacter }}</div>
          </div>
          <div class="item-line-1">
            <div class="label">联系电话</div>
            <div class="content">{{ data.workOrderModel.contactPhone }}</div>
          </div>
        </div>
        <div class="item-line-2">
          <div class="item-line-1">
            <div class="label">邮箱</div>
            <div class="content">{{ data.workOrderModel.email }}</div>
          </div>
          <div class="item-line-1">
            <div class="label">产品类型</div>
            <div class="content">{{ data.workOrderModel.productTypeName }}</div>
          </div>
        </div>
        <div class="item-line-2">
          <div class="item-line-1">
            <div class="label">产品版本</div>
            <div class="content">{{ data.workOrderModel.productVersion }}</div>
          </div>
          <div class="item-line-1">
            <div class="label">操作系统</div>
            <div class="content">{{ data.workOrderModel.os }}</div>
          </div>
        </div>
        <div class="item-line-2">
          <div class="item-line-1">
            <div class="label">CPU类型</div>
            <div class="content">{{ data.workOrderModel.cpu }}</div>
          </div>
          <div class="item-line-1">
            <div class="label">提交时间</div>
            <div class="content">{{ data.workOrderModel.submitTime }}</div>
          </div>
        </div>
        <div class="item-line-1">
          <div class="label">问题描述</div>
          <div class="content">{{ data.workOrderModel.title }}</div>
        </div>
        <div class="item-line-1">
          <div class="label">问题详情</div>
          <div :style="{'overflow': 'hidden', 'max-height': txtHeight, 'width': '100%', 'z-index': '7 !important'}" class="worksheet-detail-container">
            <div @click="e=>imageView(e)" class="content markdown-body v-note-wrapper v-note-panel v-note-show v-show-content v-note-wrapper v-note-panel v-note-show v-show-content-html" ref="txtMore" v-html="data.workOrderModel.html"></div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="txtShow" class="textMore">
      <a v-if="fold" @click="viewMore" style="color: #4771F8">展开全文<eco-icon name="arrow-down" :size="16" style="margin-left: 2px"></eco-icon></a>
      <a v-else @click="closeViewMore" style="color: #4771F8">收起<eco-icon name="arrow-down" :size="16" style="margin-left: 2px;transform: rotateX(180deg);"></eco-icon></a>
    </div>
  </div>

  <!-- 问题答案 -->
    <div v-if="(data.workOrderModel.status!=0 || data.workOrderModel.status!=4) && questionResult.content.length>0" id="questionList" class="card-item" style="padding: 24px 32px 30px 12px;">
      <div class="item-title">
        <eco-icon name="best" :size="25"></eco-icon>
        <span>问题答案</span>
      </div>
      <div style="padding:30px 0 0 20px;" class="worksheet-question-result">
        <div style="z-index: auto;padding: 24px;max-height:600px;overflow-y: scroll;display:block;" class="content markdown-body v-note-wrapper v-note-panel v-note-show v-show-content v-note-wrapper v-note-panel v-note-show v-show-content-html" v-html="questionResult.html" @click="e=>imageView(e)"></div>
        <div class="download-container" v-if="questionResult.fileList&&questionResult.fileList.length">
          <attach-list :fileList="questionResult.fileList"></attach-list>
        </div>
      </div>
    </div>

  <!-- 处理记录 -->
  <div class="card-item" style="padding: 24px 32px 30px 12px;">
    <div class="item-title">
      <eco-icon name="ask" :size="25"></eco-icon>
      <span>处理记录</span>
    </div>
    <div style="padding:10px 0 0 20px;">
      <eco-reply-list ref="reply" :commentList="CommentList" @addComment="addComment">
        <template #addComment v-if="data.workOrderModel.status===0 || data.workOrderModel.status===1">
          <flex-row class="comment-item" style="border-bottom: none;">
            <flex-fixed class="avatar">
              <eco-avatar v-if="userInfo.avatar" :user="userInfo" :size="40"></eco-avatar>
            </flex-fixed>
            <flex-fill style="overflow: hidden;background: rgba(71, 113, 248, .06);display:flex;align-items:center;justify-content: center;height: 100px;">
              <a-button type="primary" @click="beginReplyToComment">请留言</a-button>
            </flex-fill>
          </flex-row>
        </template>
      </eco-reply-list>
    </div>
  </div>

  <!-- 待评价 -->
  <div class="card-item" v-if="data.workOrderModel.status===2">
    <div class="item-title">
      <eco-icon name="evaluate" :size="25"></eco-icon>
      <span>待您评价</span>
    </div>
    <div class="item-content" style="padding: 18px 22px 0px 18px;">
      <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules" v-bind="layout" labelAlign="left" :colon="false">
        <a-form-model-item label="服务评价" prop="rate">
          <a-rate @change="handleRate" v-model="ruleForm.rate" />
        </a-form-model-item>
        <a-form-model-item label="建议与反馈" prop="advise">
          <a-textarea v-model="ruleForm.advise" />
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 14, offset: 2 }">
          <a-button type="primary" @click="handleAssess('ruleForm')">
            提交评价
          </a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
  </div>

  <!-- 评价结果 -->
  <div class="card-item" v-if="assessResult && data.workOrderModel.status===3">
    <div class="item-title">
      <eco-icon name="evaluate" :size="25"></eco-icon>
      <span>评价结果</span>
    </div>
    <div class="item-content" style="padding: 20px 30px 0px 50px;">
      <flex-row class="comment-item">
        <flex-fixed class="avatar">
          <eco-avatar v-if="userInfo.avatar" :user="userInfo" :size="40"></eco-avatar>
        </flex-fixed>
        <flex-fill style="overflow: hidden">
          <div class="username">{{ assessResult.userName }}</div>
          <div class="content">
            <div class="rate">
              <span class="label">服务评价：</span>
              <a-rate :defaultValue="parseInt(assessResult.rank)" disabled />
            </div>
            <div class="advise">
              <span class="label">建议与反馈：</span>
              {{assessResult.content}}
            </div>
          </div>
          <flex-row class="desc">
            <flex-fill class="time">
              <eco-icon name="time" :size="14" style="margin-right:4px;transform:translate(0,1px);color:#777777"></eco-icon>
              {{assessResult.createTime}}
            </flex-fill>
          </flex-row>
        </flex-fill>
      </flex-row>
    </div>
  </div>

  <!-- 预览图片 -->
  <transition name="fade">
    <div @click="preview_imgsrc=null" class="v-note-img-wrapper zoom-image-wrapper" v-if="preview_imgsrc">
      <img :src="preview_imgsrc" alt="none">
    </div>
  </transition>
</div>
</template>

<script>
import {
  getWorksheetDetail,
  revokeWorksheet,
  replyWorksheet,
  assessWorksheet
} from '@/request/worksheet'
import {
  WorksheetDetail,
  Comment
} from '@/models/Worksheet'
import {
  addCopyBtn,
  ImagePreviewListener,
  randomUUID
} from "@/utils/util"
import hljs from 'highlight.js' //导入代码高亮文件
import AttachList from './AttachList.vue'
import {
  user,
  model,
  env
} from "eco-cli";
const {
  getToken,
  login,
  getInfo,
  setToken
} = user

export default {
  components: {
    AttachList,
  },
  data() {
    return {
      data: WorksheetDetail.new(),
      CommentList: Comment.blank(), // 评论列表
      assessResult: {}, // 评价结果
      questionResult: {},
      userInfo: {},
      token: '',
      txtHeight: '320px',
      txtShow: true,
      fold: true, // 折叠
      preview_imgsrc: null,
      show: false,
      ruleForm: {
        rate: 5,
        advise: ''
      },
      rules: {
        advise: [{
          max: 1000,
          message: "输入内容字符已达上限1000个字符",
          trigger: ["blur", "change"]
        }]
      },
      layout: {
        labelCol: {
          span: 2
        },
        wrapperCol: {
          span: 20
        },
      },
    }
  },
  created() {
    this.loadWorksheetDetail()
  },
  watch: {
    data: function () {
      this.$nextTick(() => {
        // this.ifShowMore()
        setTimeout(() => {
          this.ifShowMore()
        }, 100);
      })
    },
  },
  mounted() {
    getInfo(true).then(res => {
      console.log("currentUser", res)
      this.userInfo = res;
    });
    getToken().then((res) => {
      this.token = res;
      this.headers = {
        "X-Access-Token": res
      };
    }).then(()=>{
      this.initWebSocket()
    })
  },
  destroyed() {
    //页面销毁时关闭长连接
    this.websocketOnclose();;
  },
  methods: {
    // markdown样式
    async highlighthandle() {
      await hljs;
      let highlight = document.querySelector('.worksheet-detail-container').querySelectorAll('pre code');
      let highlightReply = document.querySelector('.reply-list').querySelectorAll('pre code');
      let highlightQuestion = document.querySelector('.worksheet-question-result');
      
      if(highlightQuestion) {
        let highlightQuestionCode = highlightQuestion.querySelectorAll('pre code');

        highlightQuestionCode.forEach((block) => {
          if (!block.classList.contains('hljs')) {
            if (block.className === 'lang-language' || block.classList.length === 1) {
              block.className = 'lang-'
            }
            hljs.highlightElement(block);
          }
        });
        addCopyBtn(this, document.querySelector('.worksheet-question-result'));
      }

      highlight.forEach((block) => {
        if (!block.classList.contains('hljs')) {
          if (block.className === 'lang-language' || block.classList.length === 1) {
            block.className = 'lang-'
          }
          hljs.highlightElement(block);
        }
      })

      highlightReply.forEach((block) => {
        if (!block.classList.contains('hljs')) {
          if (block.className === 'lang-language' || block.classList.length === 1) {
            block.className = 'lang-'
          }
          hljs.highlightElement(block);
        }
      })

      addCopyBtn(this, document.querySelector('.worksheet-detail-container'));
      addCopyBtn(this, document.querySelector('.reply-list'));
    },
    // 图片预览
    imageView(event) {
      ImagePreviewListener(event, this);
    },
    // 获取工单详细
    loadWorksheetDetail() {
      const worksheetId = this.$route.params.id
      getWorksheetDetail(worksheetId).then(({
        data,
        commentList,
        assessResult,
        questionAnswer
      }) => {
        // console.log(`data, commentList, assessResult: `, data, commentList, assessResult);
        this.data = data;
        this.CommentList = commentList;
        this.assessResult = assessResult;

        if(questionAnswer) {
          this.questionResult.html = questionAnswer.html;
          this.questionResult.content = questionAnswer.content;
          this.questionResult.fileList = questionAnswer.fileList;
        }else{
          this.questionResult.html = '';
          this.questionResult.content = '';
        }

        this.$nextTick().then(() => {
          this.highlighthandle();
        })
      }).then(()=>{
        this.show = true;
      })
    },

    // 开始评论
    beginReplyToComment() {
      this.$refs.reply.beginReplyToComment();
    },

    // 新增回复
    addComment(option) {
      console.log(`回复内容： `, option);
      const params = Comment.blank({
        content: option.content,
        html: option.html,
        commentId: randomUUID(),
        worksheetId: this.$route.params.id
      })

      replyWorksheet(params).then(() => {
          this.$message.success('回复成功！');
          this.$refs.reply.closeComment(); // 关闭评论弹窗
          this.loadWorksheetDetail(); // 刷新评论列表
        })
        .catch((err) => {
          console.log(`err: `, err);
          const h = this.$createElement;
          this.$info({
            title: '提示',
            icon: () => h('a-icon', {
              props: {
                type: 'question-circle',
              },
              style: {
                color: '#faad14'
              }
            }),
            // closable: true,
            content: h('div', {}, [
              h('p', {
                domProps: {
                  innerHTML: `${err.message}<br>如有疑问，请联系右下角微信客服处理。`
                },
                style: {
                  fontSize: '14px',
                  color: 'rgba(0,0,0,.65)'
                }
              }),
            ]),
            okText: "我知道了",
            centered: true,
            onOk() {},
          });
        })
        .finally(() => {
          // this.isContentTheSame = true;
        });
    },

    // 评价
    handleAssess(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = {
            dataId: this.$route.params.id,
            rank: this.ruleForm.rate,
            content: this.ruleForm.advise
          };
          assessWorksheet(params).then(() => {
            this.$message.success('评价成功！');
            setTimeout(() => {
              window.location.reload();
            }, 2000)
          })
        } else {
          return false;
        }
      })
    },
    handleRate(value){
      if(value===0) this.ruleForm.rate =1;
    },

    // 返回
    reback() {
      this.$router.push('/worksheet')
    },

    // 撤单
    revoke() {
      const h = this.$createElement;
      this.$confirm({
        title: '提示',
        icon: () => h('a-icon', {
          props: {
            type: 'question-circle',
          },
          style: {
            color: '#faad14'
          }
        }),
        // closable: true,
        content: h('div', {}, [
          h('p', {
            domProps: {
              innerHTML: `是否确认撤销此工单？`
            },
            style: {
              fontSize: '14px',
              color: 'rgba(0,0,0,.65)'
            }
          }),
        ]),
        okText: "确认",
        cancelText: "取消",
        centered: true,
        onOk: () => {
          revokeWorksheet(this.data.workOrderModel.worksheetId).then(res => {
            this.$message.success(`${res}`)
            setTimeout(() => {
              window.location.reload();
            }, 2000)
          }).catch((err) => {
            this.$message.error(`${err}`)
          })
        },
      });
    },

    // 查看更多
    viewMore() {
      this.txtHeight = '100%'
      this.fold = false
    },

    closeViewMore() {
      this.txtHeight = "320px"
      this.fold = true
    },

    // 内容较少时”查看更多“不显示
    ifShowMore() {
      const height = this.$refs.txtMore.scrollHeight
      if (height < 320) {
        this.txtShow = false
      }
    },

    scrollEnd() {
      this.$nextTick(() => {
        const CommonBody = document.querySelector(".content-center");
        CommonBody.scrollIntoView({
          behavior: "smooth",
          block: "end",
        });
      })
    },

    // websocket
    initWebSocket() {
      const prot = location.protocol==="http:" ? "ws": "wss";
      const wsuri = `${prot}://${location.host}/eco-mq-server/work/socket/${this.token}/${this.$route.params.id}`; //ws地址
      this.websock = new WebSocket(wsuri);
      this.websock.onopen = this.websocketOnopen;
      this.websock.onerror = this.websocketOnerror;
      this.websock.onmessage = this.websocketOnmessage;
      this.websock.onclose = this.websocketOnclose;
    },

    // 客户端和服务端建立链接时触发，此时可向服务端传递参数
    websocketOnopen() {
      console.log(`webSocket open`);
      this.websock.send('crew'); //传递参数
    },

    // 客户端收到服务端发来的消息时，会触发onmessage事件，参数res.data中包含server传输过来的数据
    websocketOnmessage(res) {
      //接收到消息的回调方法，我这里是处理返回数据
      if (res && res.data && res.data.indexOf("refresh")>-1) {
        const promise = new Promise((res, rej)=>{
          res(this.loadWorksheetDetail())
        })
        promise.then(()=>{
          this.scrollEnd();
        })
        this.websock.send('*'); //传递参数
      }
      //  console.log(this.arrisrun)s
    },

    //如果出现连接，处理，接收，发送数据失败的时候就会触发onerror事件
    websocketOnerror() {
      console.log('连接失败')
    },

    //客户端收到服务端发送的关闭连接的请求时，触发onclose事件
    websocketOnclose() {
      this.websock.close()
      console.log('关闭连接')
    }
  }
}
</script>

<style lang="scss" scoped>
.card-detail {
  padding-top: 10px;

  .card-action {
    display: flex;
    justify-content: space-between;
    margin-bottom: 24px;

    .title {
      font-size: 16px;
      font-weight: 600;
      color: #222222;
      line-height: 36px;
    }
  }

  .card-item {
    padding: 24px 32px 40px 12px;
    margin-bottom: 32px;
    background: #ffffff;

    .item-title {
      padding-bottom: 22px;
      padding-left: 10px;
      border-bottom: 1px solid #eeeeee;

      span {
        font-size: 18px;
        font-weight: 400;
        color: #222222;
        line-height: 25px;
        margin-left: 6px;
        vertical-align: text-bottom;
      }
    }

    .item-content {
      padding: 34px 22px 0px 40px;

      .desc-card {
        border-bottom: 1px solid #EEEEEE;
        border-right: 1px solid #EEEEEE;
      }

      .item-line-1 {
        display: flex;

        .label {
          background: #FAFAFA;
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding-left: 15px;
          width: 163px;
          min-height: 40px;
          min-width: 163px;
          font-weight: 400;
          color: #26272A;
          font-size: 14px;
          line-height: 1.8;
          border-left: 1px solid #EEEEEE;
          border-top: 1px solid #EEEEEE;
        }

        .content {
          font-size: 14px;
          font-weight: 400;
          color: #26272A;
          line-height: 1.8;
          padding: 9px 15px;
          border-left: 1px solid #EEEEEE;
          border-top: 1px solid #EEEEEE;
          width: 100%;
          line-break: anywhere;
          word-break: break-all;
        }
      }

      .item-line-2 {
        display: grid;
        grid-template-columns: 50% 50%;
      }
    }
  }
}

.worksheet-detail-container {
  border-left: 1px solid #EEEEEE;

  .content {
    border-left: none !important;
  }
}

.textMore {
  text-align: center;
  margin-top: 19px;
}

.comment-item {
  .avatar {
    margin-right: 12px;
  }

  .username {
    font-size: 14px;
    font-weight: 600;
    color: #222222;
    line-height: 1.8;
  }

  .content {
    font-size: 14px;
    font-weight: 400;
    color: #222222;
    line-height: 1.8;

    .advise {
      margin-bottom: 10px;
      text-align: justify;
    }

    .label {
      margin-right: 14px;
    }
  }

  .desc {
    .time {
      color: #777777 !important;
      font-weight: 400;
      line-height: 22px;
      font-size: 12px;
    }
  }
}

::v-deep .ant-steps-item-title {
  font-size: 14px;
}

::v-deep .ant-steps-item-icon {
  width: 30px;
  height: 30px;
}

::v-deep .ant-steps-item-icon>.ant-steps-icon {
  vertical-align: 2px;
}

::v-deep .markdown-body p {
  font-size: 14px !important;
  line-height: 22px !important;
}
</style>
